var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContacts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "7 7 30 30",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "contacts_svg__st0",
    cx: 19,
    cy: 19,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "contacts_svg__st0",
    d: "M24 21h5M24 23.5h5M12.5 15h19v14h-19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "contacts_svg__st0",
    d: "M19 22.3c-1.7 0-3 1.3-3 3V27h6v-1.7c0-1.6-1.3-3-3-3z"
  })));
}

export default SvgContacts;